export const USER_INVITER_ID = 'USER_INVITER_ID';
export const USER_OPEN_ID = 'USER_OPEN_ID';
export const USER_UNION_ID = 'USER_UNION_ID';
export const USER_BASE_INFO = 'USER_BASE_INFO';

export const IS_STAFF = 'IS_STAFF';
export const STAFF_MENU = 'STAFF_MENU';

export const NUCALM_INFO = 'NUCALM_INFO';